import { COLORS } from '../theme'

const getScoreColor = (score: number): string => {
  const availableColors = [COLORS.errorRed, COLORS.yellow, COLORS.successGreen]
  const numColors = availableColors.length
  const colorIndex = Math.floor((score / 101) * numColors)
  return availableColors[colorIndex]
}

export default getScoreColor
